export default __webpack_public_path__ + "static/gizinski-dd42f4a66f25538a39a4cf3210ff2b60.jpg";